// @ts-check

// s_code.js needs to be loaded before this script
// s_account is localized and defined in s_code.js
var cartPage = function(s_account){
	"use strict";
	var jsMessages, origFocus, itemName,
	animate = new animations4i(),
	deleteCartItemDialog = new dialog4i(),
	cartAccordions = new getAccordions4i(),
	productScroller = new prodScroller(),
	
	init = function(){
		// empty cart
		if(document.getElementById("divHotScroller")){ 
			productScroller.InitSliderLessItems("divHotScroller");
		// not empty cart
		} else { 
			formEvents.CheckCartHasCoupon();
			formEvents.UpdateBreadCrumb();
			cartAccordions.init();
			deleteCartItemDialog.init(document.getElementById('confirmDelete'));
			
			var removeBtns = [].slice.call(document.getElementsByClassName("cartDeleteBtn"));
			removeBtns.forEach(function(el, index, array){
				el.addEventListener("click", function (e) {
					e.preventDefault();
					itemName = el.parentNode.parentNode.parentNode.parentNode.previousElementSibling.getElementsByTagName("h3")[0].textContent;
					document.getElementById("confirmDelete").getElementsByTagName('h2')[0].innerHTML = "Delete " + itemName + "?";
					deleteCartItemDialog.open();
					formEvents.GetCartItemID(el);
					document.getElementById('btnConfirmDelete').focus();
					origFocus = el;
				});
			});
			var closeDeleteBtns = [].slice.call(document.getElementById("confirmDelete").getElementsByClassName("close4iDialog"));
			closeDeleteBtns.forEach(function(el, index, array){
				el.addEventListener("click", function (e) {
					e.preventDefault();
					formEvents.RemoveCartItemID();
					origFocus.focus();
				});
			});
			document.getElementById("btnConfirmDelete").addEventListener("click", function (e) {
				e.preventDefault();
				formEvents.DeleteConfirmed();
			});
			document.getElementById("confirmDelete").addEventListener("keydown", function (e) {
				if (e.which === 27) { //escape
					formEvents.RemoveCartItemID();
				}
			});
			document.getElementById("btnClearCart").addEventListener("click", function (e) {
				e.preventDefault();
				ajaxActions.ClearCart();
			});
			document.getElementById("btnEnterCouponCode") && document.getElementById("btnEnterCouponCode").addEventListener("click", function (e) {
				e.preventDefault();
				formEvents.ShowEnterCouponCode();
			});
			document.getElementById("btnApplyCouponCode").addEventListener("click", function (e) {
				e.preventDefault();
				formEvents.SubmitCouponCode();
			});
			document.getElementById("btnCancelCouponCode").addEventListener("click", function (e) {
				e.preventDefault();
				formEvents.HideEnterCouponCode();
			});
			document.getElementById("removeCouponCode") && document.getElementById("removeCouponCode").addEventListener("click", function (e) {
				e.preventDefault();
				ajaxActions.DeleteCouponCode(this);
			});
			var priceDetailsBtns = [].slice.call(document.getElementById('divCartTable').getElementsByClassName('cartDetailsBtn'));
			priceDetailsBtns.forEach(function(el, index, array){
				el.addEventListener("click", function (e) {
					e.preventDefault();
					formEvents.ShowDetailsPopup(el);
					origFocus = el;
				});
			});
			if(document.getElementById("btnCheckOut_mini")){
				document.getElementById("btnCheckOut_mini").addEventListener("click", function(e){
					//e.preventDefault();
					formEvents.ShowBusy();
				});
			}
			document.getElementById("btnCheckOut_large").addEventListener("click", function(e){
				//e.preventDefault();
				formEvents.ShowBusy();
			});
		}

		if (!!window.performance && window.performance.navigation.type === 2) {
			// page has been hit using back or forward buttons
			document.getElementById("bodyPanel").style.display = "none";
			window.location.reload();
		}
	},
	formEvents = (function () {
		var deleteCartItemId,

		showBusy = function () {
			document.getElementsByClassName("loading")[0].classList.remove("hide");
		},
		hideBusy = function () {
			document.getElementsByClassName("loading")[0].classList.add("hide");
		},
		showEnterCouponCode = function () {
			document.getElementById("btnEnterCouponCode").classList.add("hide");
			animate.fadeIn(document.getElementById("divCouponCode"));
			document.getElementById("txtCouponCode").focus();
		},
		submitCouponCode = function () {
			var couponCode = document.getElementById("txtCouponCode").value.toUpperCase();

			if (couponCode) {
				ajaxActions.AddCouponCode(couponCode);
			} else {
				couponCodeError(jsMessages.couponError);
			}
		},
		couponCodeError = function (errMsg) {
			document.getElementById("couponCodeError").classList.remove("hide");
			document.getElementById("couponCodeError").textContent = errMsg;
			document.getElementById("couponCodeError").focus();
			document.getElementById("txtCouponCode").classList.add("input-validation-error");
		},
		hideEnterCouponCode = function () {
			document.getElementById("btnEnterCouponCode").classList.remove("hide");
			document.getElementById("btnEnterCouponCode").focus();
			document.getElementById("divCouponCode").style.display = "none";
			document.getElementById("couponCodeError").classList.add("hide");
			document.getElementById("txtCouponCode").classList.remove("input-validation-error");
			document.getElementById("txtCouponCode").value = "";
		},
		addCouponCode = function (data, code) {
			if (!data.ItemCount) {
				reloadPage();
			} else {
				hideEnterCouponCode();
				document.getElementById("cartSub").textContent = "";
				document.getElementById("removeCouponCode").setAttribute("title", document.getElementById("removeCouponCode").getAttribute("title") + code);
				document.getElementById("removeCouponCode").setAttribute("data-coupon-code", code);
				document.getElementById("couponApplied").innerHTML = code + document.getElementById("couponApplied").innerHTML;
				var cartItemCounts = document.querySelectorAll(".cartItemCount");
				for(var i = 0; i < cartItemCounts.length; i++){
					cartItemCounts[i].innerHTML = data.ItemCount;
				}
				document.getElementById("cartSub").innerHTML = data.SubTotal; 
				document.getElementById("couponDiscountAmount").innerHTML = data.CouponTotal;
				document.getElementById("divShowCouponCodes").classList.remove("hide");
				document.getElementById("orderSummaryBox").getElementsByClassName("btnCheckOut")[0].focus();
				checkCartHasCoupon();
				updateHeaderCartSummary(data);
			}
		},
		deleteCouponCode = function (data, code) {
			if (!data.ItemCount) {
				reloadPage();
			} else {
				document.getElementById("cartSub").textContent = "";
				document.getElementById("divShowCouponCodes").classList.add("hide");
				document.getElementById("removeCouponCode").setAttribute("title", document.getElementById("removeCouponCode").getAttribute("title").replace(code, ""));
				document.getElementById("removeCouponCode").setAttribute("data-coupon-code", "");
				document.getElementById("couponApplied").innerHTML = document.getElementById("couponApplied").innerHTML.replace(code, "");
				var cartItemCounts = document.querySelectorAll(".cartItemCount");
				for(var i = 0; i < cartItemCounts.length; i++){
					cartItemCounts[i].innerHTML = data.ItemCount;
				}
				document.getElementById("cartSub").innerHTML = data.SubTotal;
				document.getElementById("couponDiscountAmount").innerHTML = data.CouponTotal;
				document.getElementById("orderSummaryBox").getElementsByClassName("btnCheckOut")[0].focus();
				checkCartHasCoupon();
				updateHeaderCartSummary(data);
			}
		},
		updateItemNotifications = function (data) {
			document.getElementById("divItemNotifications").innerHTML = data.PartialView2; 
		},
		reloadPage = function () {
			location.reload(true);
		},
		checkCartHasCoupon = function () {
			if (document.getElementById("divShowCouponCodes").classList.contains("hide")) {
				document.getElementById("btnEnterCouponCode") && document.getElementById("btnEnterCouponCode").classList.remove("hide");
			} else {
				document.getElementById("btnEnterCouponCode") && document.getElementById("btnEnterCouponCode").classList.add("hide");
			}
		},
		getCartItemID = function (line) {
			deleteCartItemId = line.getAttribute("data-cart-item-id");
		},
		removeCartItemID = function () {
			deleteCartItemId = undefined;
		},
		deleteConfirmed = function () {
			ajaxActions.DeleteItem(deleteCartItemId);
		},
		removeItem = function (cartItemId, data) {
			if (!data.ItemCount) {
				reloadPage();
			} else {
				var element = document.getElementById("h3ProductInfo_" + cartItemId);
				var product = ";" + element.getAttribute("data-catalog") + " " + element.getAttribute("data-description").replace("\"", "") + ";" + element.getAttribute("data-quantity") + ";" + element.getAttribute("data-price");

				document.getElementById("divCartItem_" + cartItemId).parentNode.removeChild(document.getElementById("divCartItem_" + cartItemId));
				var cartItemCounts = document.querySelectorAll(".cartItemCount");
				for(var i = 0; i < cartItemCounts.length; i++){
					cartItemCounts[i].innerHTML = data.ItemCount;
				}
				var cartsub = document.getElementsByClassName("cartSubtotal");
                
                for(var x=0; x < cartsub.length; x++){
                    cartsub[x].innerHTML = data.SubTotal;
                }

				document.getElementById("couponDiscountAmount").innerHTML = data.CouponTotal;
				updateHeaderCartSummary(data);
				updateItemNotifications(data);
				checkCouponRemoved(data);
				hideBusy();

				return product;
			}
		},
		checkCouponRemoved = function (data) {
			var code = document.getElementById("removeCouponCode").getAttribute("data-coupon-code");

			// remove dollar and cents symbol
			if (code && parseFloat(data.CouponTotal.replace(/(&#[0-9]+;)|(&[A-Za-z0-9]+;)|,/g, "")) === 0) {
				deleteCouponCode(data, code);
			}
		},
		updateHeaderCartSummary = function (data) {
			if (data.PartialView1) {
				document.getElementById("userSpecificLinksBox").querySelectorAll(".cartSummaryContainer")[0].innerHTML = data.PartialView1;
				var headerLinks = new header4i();
				headerLinks.init_cartsummary();
			}
		},
		updateBreadCrumb = function () {
			var url = document.getElementById("orderSummaryBox").getElementsByClassName("btnCheckOut")[0].getAttribute("href");
			var parent = document.getElementById("divShipPymtBC").parentNode;

			if (parent.tagName !== "a") {
				parent.innerHTML = "<a href='" + url + "' class='show noLine'>" + parent.innerHTML + "</a>";
			}
		},
		showDetailsPopup = function (element) {
			removeDetailsPopup();
			element.setAttribute("aria-expanded", "true");
			element.insertAdjacentHTML('afterend', '<div id="cartDetailsPopup"></div>');
			ajaxActions.GetItemDetails(element);
		},
		removeDetailsPopup = function () {
			var popup = document.getElementById('cartDetailsPopup');
			if(popup){
				popup.previousElementSibling.setAttribute("aria-expanded", "false");
				popup.parentNode.removeChild(popup);
			}
		},
		updateDetailsPopup = function (data) {
			var popup = document.getElementById('cartDetailsPopup');

			popup.innerHTML = data;
			hideBusy();

			var itemDetailsDialog = dialog4i();
			itemDetailsDialog.init(document.getElementById('divItemDetails'));
			itemDetailsDialog.open();

			document.getElementById("divItemDetails").getElementsByClassName("close4iDialog")[0].addEventListener("click", function (e) {
				e.preventDefault();
				formEvents.RemoveDetailsPopup();
				origFocus.focus();
			});
			document.getElementById("divItemDetails").addEventListener("keydown", function (e) {
				if (e.which === 27) { /*esc*/
					formEvents.RemoveDetailsPopup();
					origFocus.focus();
				}
			});
		},
		updateHotScroller = function (data) {
			document.getElementById("divHotScroller").innerHTML = data;
		},
		showAjaxMessage = function (msg) {
			document.getElementById("divNotification").innerHTML = msg;
			document.getElementById("divNotification").classList.remove("hide");
			document.getElementById("divNotification").focus();
		},
		hideAjaxMessage = function () {
			document.getElementById("divNotification").classList.add("hide");
		};

		return {
			GetCartItemID: getCartItemID,
			RemoveCartItemID: removeCartItemID,
			DeleteConfirmed: deleteConfirmed,
			ShowEnterCouponCode: showEnterCouponCode,
			HideEnterCouponCode: hideEnterCouponCode,
			SubmitCouponCode: submitCouponCode,
			CouponCodeError: couponCodeError,
			AddCouponCode: addCouponCode,
			DeleteCouponCode: deleteCouponCode,
			RemoveItem: removeItem,
			ShowAjaxMessage: showAjaxMessage,
			HideAjaxMessage: hideAjaxMessage,
			ShowBusy: showBusy,
			HideBusy: hideBusy,
			ReloadPage: reloadPage,
			RemoveDetailsPopup: removeDetailsPopup,
			ShowDetailsPopup: showDetailsPopup,
			UpdateDetailsPopup: updateDetailsPopup,
			UpdateHotScroller: updateHotScroller,
			UpdateBreadCrumb: updateBreadCrumb,
			CheckCartHasCoupon: checkCartHasCoupon
		};
	}()),
	ajaxActions = (function () {
		var antiForgeryToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? { "__RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value } : "",
		cartId = document.getElementById("UserCart_CartID") ? document.getElementById("UserCart_CartID").value : "",

		getMessages = function () {
			var getText = ajax({
				url: '/cart/javascriptMessages/cart',
				method: 'GET'
			});
			getText.then(function(response, xhr){
				jsMessages = response;
			});
			getText.catch(function(response, xhr){
				return null;
			});
		},
		deleteItem = function (cartItemId) {
			formEvents.ShowBusy();
			formEvents.RemoveCartItemID();
			deleteCartItemDialog.close();

			var deleteCartItem = ajax({
				url: '/cart/deleteitem',
				method: 'POST',
				data: { cartId: cartId, cartItemId: cartItemId },
				headers: antiForgeryToken
			});
			deleteCartItem.then(function(response, xhr){
				if (response.Success) {
					omniture.RemoveItem(formEvents.RemoveItem(cartItemId, response));
					formEvents.HideAjaxMessage();
					if(document.getElementById("itemRemovalAlert")){
						document.getElementById("itemRemovalAlert").parentNode.removeChild(document.getElementById("itemRemovalAlert"));
					}
					//notify screen readers that item has been deleted
					document.querySelector("h1").insertAdjacentHTML("afterend", '<div id="itemRemovalAlert" class="visually-hidden" role="alert" aria-atomic="true"></div>');
					document.getElementById("itemRemovalAlert").textContent = itemName + " removed from your cart.";
					document.getElementById("cartLinks").getElementsByTagName("a")[0].focus();
					formEvents.HideBusy();
				} else {
					formEvents.ShowAjaxMessage(jsMessages.deleteFailed);
					formEvents.HideBusy();
				}
			});
			deleteCartItem.catch(function(response, xhr){
				formEvents.ShowAjaxMessage(jsMessages.deleteFailed);
				formEvents.HideBusy();
			});
		},
		addCouponCode = function (code) {
			formEvents.ShowBusy();
			var addTheCoupon = ajax({
				url: '/cart/addcoupon',
				method: 'POST',
				data: { cartId: cartId, couponCode: code },
				headers: antiForgeryToken
			});
			addTheCoupon.then(function(response, xhr){
				if (response.Success) {
					formEvents.AddCouponCode(response, code);
					omniture.AddCouponCode(code);
					formEvents.HideBusy();
				} else {
					formEvents.CouponCodeError(response.Message);
					formEvents.HideBusy();
				}
			});
			addTheCoupon.catch(function(response, xhr){
				formEvents.CouponCodeError(jsMessages.couponError);
				formEvents.HideBusy();
			});
		},
		deleteCouponCode = function (coupon) {
			formEvents.ShowBusy();
			var code = coupon.getAttribute("data-coupon-code");
			var deleteTheCoupon = ajax({
				url: '/cart/deletecoupon',
				method: 'POST',
				data: { cartId: cartId, couponCode: code },
				headers: antiForgeryToken
			});
			deleteTheCoupon.then(function(response, xhr){
				if (response.Success) {
					formEvents.DeleteCouponCode(response, code);
					formEvents.HideAjaxMessage();
					formEvents.HideBusy();
				} else {
					formEvents.ShowAjaxMessage(response.Message);
					formEvents.HideBusy();
				}
			});
			deleteTheCoupon.catch(function(response, xhr){
				formEvents.ShowAjaxMessage(jsMessages.deleteCouponError);
				formEvents.HideBusy();
			});
		},
		clearCart = function () {
			formEvents.ShowBusy();
			var clearEverything = ajax({
				url: '/cart/clearCart',
				method: 'POST',
				data: { cartId: cartId },
				headers: antiForgeryToken
			});
			clearEverything.then(function(response, xhr){
				if (response.Success) {
					var isMessage = response.Message ? true : "";
					if(isMessage !== ""){
						omniture.RemoveItem(response.Message);
					}
					formEvents.ReloadPage();
				} else {
					formEvents.ShowAjaxMessage(response.Message);
					formEvents.HideBusy();
				}
			});
			clearEverything.catch(function(response, xhr){
				formEvents.ShowAjaxMessage(jsMessages.clearCartError);
				formEvents.HideBusy();
			});
		},
		getItemDetails = function (line) {
			formEvents.ShowBusy();
			var getDetails = ajax({
				url: '/cart/itemdetails',
				method: 'POST',
				data: { cartId: cartId, cartItemId: line.getAttribute("data-cart-item-id") },
				headers: antiForgeryToken
			});
			getDetails.then(function(response, xhr){
				formEvents.UpdateDetailsPopup(response);
				formEvents.HideAjaxMessage();
				formEvents.HideBusy();
			});
			getDetails.catch(function(response, xhr){
				formEvents.RemoveDetailsPopup();
				formEvents.ShowAjaxMessage(jsMessages.getItemDetailsError);
				formEvents.HideBusy();
			});
		},
		getHotItems = function () {
			var hotProducts = ajax({
				url: '/productscroller/hotitems',
				method: 'GET'
			});
			hotProducts.then(function(response, xhr){
				formEvents.UpdateHotScroller(response);
			});
		};
		
		getMessages(); // ajax call to get error messages

		return {
			DeleteItem: deleteItem,
			AddCouponCode: addCouponCode,
			DeleteCouponCode: deleteCouponCode,
			ClearCart: clearCart,
			GetItemDetails: getItemDetails,
			GetHotItems: getHotItems
		};
	}()),
	
	omniture = (function (s_account) {
		var account = s_account ? s_account : "4imprintprod",
		addCouponCode = function (couponCode) {
			var s = s_gi(account);
			s.linkTrackVars = 'eVar5,events';
			s.linkTrackEvents = 'event2';
			s.eVar5 = couponCode;
			s.events = 'event2';
			s.tl(true, 'o', 'Coupon Codes');
		},
		removeItem = function (product) {
			var s = s_gi(account);
			s.linkTrackVars = 'products,events';
			s.linkTrackEvents = 'scRemove';
			s.events = 'scRemove';
			s.products = product;
			s.tl(true, 'o', 'Cart Delete Item');
		};

		return {
			AddCouponCode: addCouponCode,
			RemoveItem: removeItem
		};
	}(s_account));
	
	return {
		init: init
	};
};

(function(){
	var cart = new cartPage(s_account);
	cart.init();
})();